"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  themeObject: true,
  themeConstants: true
};
exports.themeObject = exports.themeConstants = exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _breakpoints = _interopRequireDefault(require("./breakpoints"));
var components = _interopRequireWildcard(require("./components"));
var _palette = _interopRequireDefault(require("./palette"));
var _shadows = _interopRequireWildcard(require("./shadows"));
Object.keys(_shadows).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _shadows[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _shadows[key];
    }
  });
});
var _shape = _interopRequireDefault(require("./shape"));
var _spacing = _interopRequireDefault(require("./spacing"));
var _typography = _interopRequireDefault(require("./typography"));
var _themeConstants = _interopRequireWildcard(require("./constants"));
exports.themeConstants = _themeConstants;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const themeObject = exports.themeObject = {};
themeObject.shape = _shape.default;
themeObject.breakpoints = _breakpoints.default;
themeObject.components = components;
themeObject.palette = _palette.default;
themeObject.shadows = _shadows.default;
themeObject.spacing = _spacing.default;
themeObject.typography = _typography.default;
const theme = (0, _material.createTheme)(themeObject);
var _default = exports.default = theme;
//# sourceMappingURL=index.js.map